import { MenuPopper, Text, token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledMenuPopper = styled(MenuPopper)`
  display: block;
  border-radius: ${token('radii.lg')}px;
  cursor: pointer;

  &:hover {
    background-color: ${token('colors.blue100')};
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;
  padding: 12px;
`;

export const StyledDisplayNameOrEmailText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledChevronIconContainer = styled.div<{ offsetTop?: number }>`
  display: flex;

  top: ${({ offsetTop = 0 }) => `${offsetTop}px`};
  position: relative;
`;
